import { render, staticRenderFns } from "./ScriptoriumSelect.vue?vue&type=template&id=5cd5ecd6&"
import script from "./ScriptoriumSelect.vue?vue&type=script&lang=js&"
export * from "./ScriptoriumSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports